import { useQueryParams } from "lib/hooks/useQueryParams";
import { useGetPreferences } from "api/preferences/useGetPreferences";
import { PUB_LANG } from "redux/slices/api/initialisePreferences";
import { getFeaturedReportFilters, getTermFilters, getAssetClassFilters } from "./useGetFilters";

export const useCreateFeaturedSearchRequest = () => {
  const qs = useQueryParams();
  const pubLangPref = useGetPreferences(PUB_LANG);

  const getLanguageFilter = (termFilters) => {
    if (termFilters.language) return { language: termFilters.language };
    return {};
  };

  try {
    const assetFilters = getAssetClassFilters(qs);
    const featuredFilters = getFeaturedReportFilters();
    const termFilters = getTermFilters(qs, pubLangPref);
    const langFilter = getLanguageFilter(termFilters);
    const request = {
      filters: { ...featuredFilters, ...langFilter },
      size: 3,
      restFilters: { ...termFilters, ...assetFilters },
    };

    return request;
  } catch (err) {
    console.error("Error creating featured search request:", err);
    return {};
  }
};
